// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.course-search{
    outline: none;
    border: none;
    width: 90vw;
    font-size: .9rem;
    padding: 16px;
    background-color: #F0F0F0;
    border-radius: .8rem;
    box-shadow: 5px 5px 10px rgb(213, 213, 213);
}
.course-search1{
    box-shadow: 0 0 transparent !important;
    width: 60vw;
}
.course-btn-search{
    border: none;
    position: absolute;
    top: 8px;
    left: 8px;
}
.course-btn-search1{
    border: none;
    position: absolute;
    top: 32px;
    left: 32px;
}
.btn-search-dsk{
    background-color: #2BA769;
    border-radius: 10px;
    width: 70vw;

}

.btn-search-dsk input{
width: 40vw;
}

.course-btn{
    outline: none;
    border:none;
    width: 160px;
    height: 50px;
    border-radius: 24px;
    color: white;
    background-color: #2BA769;
}
.bg-light1{
    color: black;
    background-color: white !important;
   
}
.scrollbar{
    width: 145px;
    height: 22px;
    background-color: #F5F9FF;
    border: 3px solid #E8F1FF;
    border-radius: 8px;
}
.scrollbar-segment{
    border-radius: 6px;
}
.course-container{
    background-color: white;
    border-radius: 16px 0 0 16px;
    padding: 20px;
}

.w-lg-75{
    width: 94%;
}

@media (max-width:990px) {
    
    .w-100-ph{
    width: 100% !important;
}
.course-container{
    padding:20px 10px !important;
}
.w-lg-75{
    width: 100%;
}
}

/* انیمیشن برای دکمه قلب */
.heart-button {
    transition: transform 0.2s ease, opacity 0.2s ease !important;
}

.heart-button:hover:not(:disabled) {
    transform: scale(1.1);
}

.heart-button:active:not(:disabled) {
    transform: scale(0.95);
}

/* اسپینر برای بارگذاری */
.spinner-border {
    width: 2rem;
    height: 2rem;
}

/* استایل اسکرول برای نوار پیشرفت */
.scrollbar-segment {
    transition: background-color 0.3s ease;
}

`, "",{"version":3,"sources":["webpack://./src/styles/course.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,oBAAoB;IACpB,2CAA2C;AAC/C;AACA;IACI,sCAAsC;IACtC,WAAW;AACf;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;;AAEf;;AAEA;AACA,WAAW;AACX;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,kCAAkC;;AAEtC;AACA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI;IACA,sBAAsB;AAC1B;AACA;IACI,4BAA4B;AAChC;AACA;IACI,WAAW;AACf;AACA;;AAEA,0BAA0B;AAC1B;IACI,6DAA6D;AACjE;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,mCAAmC;AACnC;IACI,sCAAsC;AAC1C","sourcesContent":["\n.course-search{\n    outline: none;\n    border: none;\n    width: 90vw;\n    font-size: .9rem;\n    padding: 16px;\n    background-color: #F0F0F0;\n    border-radius: .8rem;\n    box-shadow: 5px 5px 10px rgb(213, 213, 213);\n}\n.course-search1{\n    box-shadow: 0 0 transparent !important;\n    width: 60vw;\n}\n.course-btn-search{\n    border: none;\n    position: absolute;\n    top: 8px;\n    left: 8px;\n}\n.course-btn-search1{\n    border: none;\n    position: absolute;\n    top: 32px;\n    left: 32px;\n}\n.btn-search-dsk{\n    background-color: #2BA769;\n    border-radius: 10px;\n    width: 70vw;\n\n}\n\n.btn-search-dsk input{\nwidth: 40vw;\n}\n\n.course-btn{\n    outline: none;\n    border:none;\n    width: 160px;\n    height: 50px;\n    border-radius: 24px;\n    color: white;\n    background-color: #2BA769;\n}\n.bg-light1{\n    color: black;\n    background-color: white !important;\n   \n}\n.scrollbar{\n    width: 145px;\n    height: 22px;\n    background-color: #F5F9FF;\n    border: 3px solid #E8F1FF;\n    border-radius: 8px;\n}\n.scrollbar-segment{\n    border-radius: 6px;\n}\n.course-container{\n    background-color: white;\n    border-radius: 16px 0 0 16px;\n    padding: 20px;\n}\n\n.w-lg-75{\n    width: 94%;\n}\n\n@media (max-width:990px) {\n    \n    .w-100-ph{\n    width: 100% !important;\n}\n.course-container{\n    padding:20px 10px !important;\n}\n.w-lg-75{\n    width: 100%;\n}\n}\n\n/* انیمیشن برای دکمه قلب */\n.heart-button {\n    transition: transform 0.2s ease, opacity 0.2s ease !important;\n}\n\n.heart-button:hover:not(:disabled) {\n    transform: scale(1.1);\n}\n\n.heart-button:active:not(:disabled) {\n    transform: scale(0.95);\n}\n\n/* اسپینر برای بارگذاری */\n.spinner-border {\n    width: 2rem;\n    height: 2rem;\n}\n\n/* استایل اسکرول برای نوار پیشرفت */\n.scrollbar-segment {\n    transition: background-color 0.3s ease;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
